import EF from 'ef/ef';
import _ from 'lodash';
import $ from 'jquery';

const SiteService = function () {
  this.addSponsorClass = function () {
    EF.program.fetch().done(function () {
      _.each(EF.program.get('sponsorships'), function (sponsor) {
        $('body').addClass(sponsor.slug);
      });
    });
  };
};

export default new SiteService();
